// extracted by mini-css-extract-plugin
export default {"asset":"MediaPreview_asset__ohyaU","playIcon":"MediaPreview_playIcon__OMl3r"};